const statDonut = {
  init: function () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        observer.unobserve(entry.target);
        let percentage = entry.target.dataset.percentage;
        this.animateDonut(
          this.animationEaseTiming,
          (progress) => {
            const animatedPercentage = percentage * progress;
            const animatedText = '"' + Math.round(animatedPercentage) + '%"';

            entry.target.style.setProperty(
              "--donut-percentage",
              animatedPercentage
            );
            entry.target.style.setProperty(
              "--donut-text-percentage",
              animatedText
            );

            // Also update the donut element if it exists
            const donutElement = entry.target.closest(".donut");
            if (donutElement) {
              donutElement.style.setProperty(
                "--donut-percentage",
                animatedPercentage
              );
              donutElement.style.setProperty(
                "--donut-text-percentage",
                animatedText
              );
            }
          },
          1500
        );
      });
    });

    document
      .querySelectorAll(".stat-donut-section .stat-block.stat-block-animate")
      .forEach(function (statBlock) {
        observer.observe(statBlock);
      });
    document
      .querySelectorAll(".donut--slider .stat-block.stat-block-animate")
      .forEach(function (statBlock) {
        observer.observe(statBlock);
      });
  },
  animateDonut: function (timing, draw, duration) {
    let start;

    function step(time) {
      if (!start) {
        start = time;
      }
      // timeFraction goes from 0 to 1
      let timeFraction = (time - start) / duration;
      if (timeFraction > 1) {
        timeFraction = 1;
      }
      // calculate the current animation state
      let progress = timing(timeFraction);

      draw(progress); // draw it

      if (timeFraction < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  },
  animationEaseTiming: (timeFraction) =>
    (Math.sin((timeFraction - 0.5) * Math.PI) + 1) / 2,
};

// Carousel functionality
const donutCarousel = {
  slideIndex: 1,

  init: function () {
    this.showSlides(this.slideIndex);
  },

  nextSlide: function () {
    this.showSlides((this.slideIndex += 1));
  },

  prevSlide: function () {
    this.showSlides((this.slideIndex -= 1));
  },

  currentSlide: function (n) {
    this.showSlides((this.slideIndex = n));
  },

  showSlides: function (n) {
    const slides = document.querySelectorAll(".donut--slide");
    const dots = document.querySelectorAll(".carousel-dot");

    if (n > slides.length) {
      this.slideIndex = 1;
    }
    if (n < 1) {
      this.slideIndex = slides.length;
    }

    slides.forEach((slide) => slide.classList.remove("active"));
    dots.forEach((dot) => dot.classList.remove("active"));

    if (slides[this.slideIndex - 1]) {
      slides[this.slideIndex - 1].classList.add("active");
    }
    if (dots[this.slideIndex - 1]) {
      dots[this.slideIndex - 1].classList.add("active");
    }

    const slidesContainer = document.querySelector(".donut--slides");
    if (slidesContainer) {
      slidesContainer.style.transform = `translateX(${
        -(this.slideIndex - 1) * 100
      }%)`;
    }

    // Animate the active slide's donut
    const activeSlide = slides[this.slideIndex - 1];
    if (activeSlide) {
      const statBlock = activeSlide.querySelector(
        ".stat-block.stat-block-animate"
      );
      if (statBlock) {
        statDonut.resetAndAnimate(statBlock);
      }
    }
  },

  resetAndAnimate: function (element) {
    const percentage = element.dataset.percentage;
    const donutElement = element.closest(".donut");

    if (donutElement) {
      donutElement.style.setProperty("--donut-percentage", "0");
      donutElement.style.setProperty("--donut-text-percentage", '"0%"');
    }
    element.style.setProperty("--donut-percentage", "0");
    element.style.setProperty("--donut-text-percentage", '"0%"');

    statDonut.animateDonut(
      statDonut.animationEaseTiming,
      (progress) => {
        const animatedPercentage = percentage * progress;
        const animatedText = '"' + Math.round(animatedPercentage) + '%"';

        if (donutElement) {
          donutElement.style.setProperty(
            "--donut-percentage",
            animatedPercentage
          );
          donutElement.style.setProperty(
            "--donut-text-percentage",
            animatedText
          );
        }
        element.style.setProperty("--donut-percentage", animatedPercentage);
        element.style.setProperty("--donut-text-percentage", animatedText);
      },
      1500
    );
  },
};

// Add global functions for HTML onclick handlers
window.nextSlide = function () {
  donutCarousel.nextSlide();
};

window.prevSlide = function () {
  donutCarousel.prevSlide();
};

window.currentSlide = function (n) {
  donutCarousel.currentSlide(n);
};

document.addEventListener("DOMContentLoaded", function () {
  statDonut.init();

  // Initialize carousel if it exists
  if (document.querySelector(".donut--slider")) {
    donutCarousel.init();
  }
});
